/**
 * userDataDisplay config values
 * per userDataDisplay KMS config, userSelect section
 */
export enum UserDataDisplayConfig {
    name = "name",
    email = "email",
    id = "id",
}

export type UserDataDisplayType = UserDataDisplayConfig[];
